import { postRequest } from "../config/axiosConfig";
import { SubmitAnswersRequest } from "../interfaces";

const TEST_MODE_PARAM_NAME = "testMode";

class SubmitAnswersService {
  baseUrl: string;

  constructor() {
    this.baseUrl = "answers/" + process.env.REACT_APP_WEBSITE_BRAND;
  }
  async submitAnswers(body: SubmitAnswersRequest) {
    const isTestEnvironment = ["DEV", "INT"].includes(
      process.env.REACT_APP_STAGE?.toUpperCase() ?? "",
    );

    const isTestMode =
      new URLSearchParams(window.location.search).get(TEST_MODE_PARAM_NAME) ===
      "true";

    const additionalHeaders =
      isTestEnvironment && isTestMode ? { "x-test-mode": "true" } : undefined;
    return await postRequest(`${this.baseUrl}`, body, additionalHeaders);
  }
}

export default SubmitAnswersService;
